import { render, staticRenderFns } from "./icon_aliment.vue?vue&type=template&id=2442be75&scoped=true&"
import script from "./icon_aliment.vue?vue&type=script&lang=js&"
export * from "./icon_aliment.vue?vue&type=script&lang=js&"
import style0 from "./icon_aliment.vue?vue&type=style&index=0&id=2442be75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442be75",
  null
  
)

export default component.exports